import React from "react";
import { IMaskInput } from "react-imask";
import { IMaskInputProps } from "react-imask/mixin";

export type MaskedInputProps = Omit<
  IMaskInputProps<HTMLInputElement>,
  "onChange" | "inputRef"
> & {
  onChange: (event: { target: { name: string; value: string } }) => void;
};

// @ts-expect-error Force type to be IMaskInput so props resolving based on mask type works
export const MaskedInput: typeof IMaskInput = React.forwardRef<
  HTMLInputElement,
  MaskedInputProps
>(({ onChange, name, onAccept, ...other }, ref) => {
  return (
    // @ts-expect-error The mask prop type is causing issues
    <IMaskInput
      {...other}
      inputRef={ref}
      name={name}
      onAccept={(value, ...rest) => {
        onAccept?.(value, ...rest);
        onChange({
          target: { name, value },
        });
      }}
      defaultValue={other.value}
    />
  );
});

MaskedInput.displayName = "MaskedInput";
